"use strict";
/**
 * @copyright   2016-2018, Miles Johnson
 * @license     https://opensource.org/licenses/MIT
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var prop_types_1 = __importDefault(require("prop-types"));
exports.FilterShape = prop_types_1.default.shape({
    attribute: prop_types_1.default.func,
    node: prop_types_1.default.func,
});
exports.MatcherShape = prop_types_1.default.shape({
    asTag: prop_types_1.default.func.isRequired,
    createElement: prop_types_1.default.func.isRequired,
    inverseName: prop_types_1.default.string.isRequired,
    match: prop_types_1.default.func.isRequired,
    onAfterParse: prop_types_1.default.func,
    onBeforeParse: prop_types_1.default.func,
    propName: prop_types_1.default.string.isRequired,
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/interweave/lib/shapes.js
// module id = 282
// module chunks = 0